import { graphql } from '@api/generated';
import { VirtualAgentFiltersForConversationsPageQuery } from '@api/generated/graphql';

export const virtualAgentFiltersQuery = graphql(`
  query VirtualAgentFiltersForConversationsPage {
    virtualAgentFilters {
      defaultSettings {
        defaultId
        virtualAgent
      }
      accounts {
        agentId
        virtualAgent
        legacyDefaultId
        tenant {
          id
        }
      }
    }
  }
`);

export type VirtualAgentFiltersQueryResult =
  VirtualAgentFiltersForConversationsPageQuery;
